import _Runfest from './Runfest'
import _Link from './view/components/Link'
import _Router from './view/components/Router'
import _ConvertRouter3DefTo4 from './util/ConvertRouter3DefTo4'
import _GetSearchObject from './util/GetSearchObject'
// import _Router from './view/components/Router'

export const Router = _Router
export const Link = _Link
export const GetSearchObject = _GetSearchObject
export const Runfest = _Runfest
export const Router4Runfest = _Runfest
export const ConvertRouter3DefTo4 = _ConvertRouter3DefTo4
export const syncHistoryWithStore = _Runfest.syncHistoryWithStore
